<template>
    
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="m-0" style="margin-bottom: 10px !important">Beranda Admin</h3>
                    <p class="mb-0">Menu ini untuk fitur2 tentang Kang Tagih, Teknisi dan Voucher ya gan :)</p>

                    <div class="row mt-4">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="card mt-0 card-stats">
                                <div class="box-horizontal mb-0">
                                    <div class="box-menu text-center pointer" @click="link.tugas()" v-show="false">
                                        <i class="material-icons d-block text-info">list</i>
                                        Tugas Teknisi <span class="badge badge-warning ml-2">{{data.tugasJumlah}}</span>
                                    </div>
                                    <div class="box-menu text-center pointer" @click="link.kangtagih()">
                                        <i class="material-icons d-block text-warning">people</i>
                                        Kang Tagih
                                    </div>
                                    <div class="box-menu text-center pointer" @click="link.teknisi()">
                                        <i class="material-icons d-block text-success">people</i>
                                        Kang Teknisi
                                    </div>
                                    <div class="box-menu text-center pointer" @click="link.voucher()">
                                        <i class="material-icons d-block text-warning">spa</i>
                                        Kang Voucher
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-12">
                  <div class="card mt-3">
                    <div class="card-body">
                      <h3 class="m-0">Tugas Selesai Hari ini</h3>
                      <p class="mb-0">Kumpulan tugas yang telah selesai di hari ini ya gan :)</p>
                        <!--
                        <div class="row">
                          <div class="col-md-4" v-show="data.tanggalBox">
                            <label for="tanggal" class="text-dark">Pilih Tanggal</label>
                            <div class="box-horizontal">
                              <vuejs-datepicker :format="theGet.customFormatter" id="tanggal" type="text" placeholder="Pilih Tanggal..." v-model="data.tanggal" style="width: 100%"></vuejs-datepicker>
                            </div>
                          </div>
                        </div>
                        -->

                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th>Tugas</th>
                            <th>Pelanggan</th>
                            <th>Job</th>
                            <th>Teknisi</th>
                            <th>Status</th>
                            <th>Kerusakan</th>
                            </thead>
                            <!-- LOADING -->
                            <tbody v-show="data.loading">
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            </tbody>
                            <!-- DATA -->
                            <tbody v-show="!data.loading">
                            <tr v-for="(u, index) in theGet.datax.List">
                                <td>
                                  <strong class="d-block text-info p-1">Tugas #{{ u.fake_id }}</strong>
                                  <span class="d-block">{{myGlobal.tglIndo(u.tanggal)}}</span>
                                </td>
                                <td>
                                    <span class="d-block">{{ u.unama }}</span>
                                    <span class="d-block text-secondary">{{ u.wa }}</span>
                                    <span class="d-block text-secondary">{{ u.anama }}</span>
                                </td>
                                <td>
                                  {{u.teks}}
                                </td>
                                <td>
                                  {{u.proses_oleh}}
                                </td>
                                <td>
                                    <div v-if="u.status == 'pending'">
                                      <span class="d-block text-warning">Pending</span>
                                      <span class="d-block text-gray">{{u.jam}} - {{ myGlobal.tglIndo(u.tanggal) }}</span>
                                    </div>
                                    <div v-else-if="u.status == 'proses'">
                                      <span class="d-block text-info">Proses</span>
                                      <span class="d-block text-gray">{{u.jam_proses}} - {{ myGlobal.tglIndo(u.tgl_proses) }}</span>
                                    </div>
                                    <div v-else-if="u.status == 'done'">
                                      <span class="d-block text-success">Selesai</span>
                                      <span class="d-block text-gray">{{u.jam_selesai}} - {{ myGlobal.tglIndo(u.tgl_selesai) }}</span>
                                    </div>
                                </td>
                                <td>
                                  {{u.kerusakan}}
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.datax.List == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
                
            </div>

        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';
import Loading from '@/globalFunc/Loading' 

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import router from '@/router'

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 
    "Loading" : Loading

  }, 
  setup() {
    const data = reactive({
        
      // ABSENSI MODAL
      namaQ: null,
      namaAbsensi: null,
      modalCekSingkron: true,
      loadingBox: true,
      baru: false,
      tugasJumlah: 0,
      loading: true
    })

    const theGet = {
        datax: reactive({
          List: [],
        }),
        
        loginSubmit() {
            var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            nama: sessionStorage.getItem('admin')
            };
        
            var apiUrl = inter.loginSubmit();
            myGlobal.callAbsensi(datax,apiUrl).then(x => {
                //myGlobal.loger(x);

                if (x.status == true) {
                //data.baru = true;
                sessionStorage.setItem('myTokenAbsensi', x.data);

                data.modalCekSingkron = false;

                //theGet.dataeNow();
                
                } else {
                //theGet.data.List = null;
                    alert(x.pesan)
                }
                
            })
        },
        AmbilJumlahTugas() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }

            var apiUrl = inter.TugasJumlah();
            myGlobal.call(datax,apiUrl).then(x => {
                //this.loger(x);

                if(x.status) {
                    let datae = x.data;
                    data.tugasJumlah = datae;
                }
            })

        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        dataeNow() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                from: "web",
                status: "done",
                tanggal: this.customFormatter(new Date())
            };

            if(data.teknisiID != null) {
                datax["teknisi"] = data.teknisiID
            }
            //console.log(JSON.stringify(datax))
        
            var apiUrl = inter.TugasList();
            myGlobal.call(datax,apiUrl).then(x => {
            
                // myGlobal.loger(x);

                data.loading = false;

                if (x.status == true) {
                    this.datax.List = x.data;
                    this.datax.Total = x.pesan.masuk;
                } else {
                    theGet.datax.List = null;
                }
            })
        },
        datae() {
            data.loading = true;
            setTimeout(function() {
                theGet.dataeNow();
            }, 1000);
        },
    }
    const link = {
        tugas() {
            router.push({ 
                name: 'tugas'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },

        kangtagih() {
            router.push({ 
                name: 'admin-kangtagih'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        teknisi() {
            router.push({ 
                name: 'admin-teknisi'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        voucher() {
            router.push({ 
                name: 'kang-voucher'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        detail(kategori) {
            let isCustom = myGlobal.isCustom();
            if (isCustom == null) {
                alert("hehe, maap gan. fitur detail cuma untuk custom ya")
                return false;
            }
            // LANJOT CUSTOM TERNYATA

            router.push({ 
                name: 'pembukuan-pengeluaran',
                params: {
                    kategori: kategori
                } 
            });
        },
    }

    return {
      data, 
      theGet,
      myGlobal,
      link
    }
  },
  mounted () {
    document.title = "Pembukuan";

    // this.theGet.AmbilJumlahTugas();
    
    this.theGet.dataeNow();

  }
}

/**
 * DETAIL TIAP KATEGORI
 * DETAIL CUSTOM ONLY
 * LINK KAN MENU LAIN LAIN
 */

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.box-menu {
    padding: 15px;
}
.box-menu > i {
    font-size: 35pt;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/beranda.vue